var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from 'axios';
class CoinCloudApiWrapper {
    constructor(config) {
        this.config = config;
    }
    setUserTags(tags) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield axios.post(`${CoinCloudApiWrapper.userTagsEndPoint}/user/tags`, tags, {
                headers: {
                    Authorization: this.config.auth,
                },
            });
        });
    }
    getUserStats() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.userStats === undefined) {
                yield this.fetchUserStats();
            }
            return this.userStats;
        });
    }
    fetchUserStats() {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield axios.get(`${CoinCloudApiWrapper.userDashboardEndPoint}/dashboard`, {
                headers: {
                    'X-Auth-Token': this.config.auth,
                },
            });
            if ((_a = result.data) === null || _a === void 0 ? void 0 : _a.success) {
                this.userStats = (_b = result.data) === null || _b === void 0 ? void 0 : _b.result;
                return (_c = result.data) === null || _c === void 0 ? void 0 : _c.result;
            }
            this.userStats = null;
            throw Error('Cloud Function Error');
        });
    }
    static get(config) {
        return new CoinCloudApiWrapper(config);
    }
}
CoinCloudApiWrapper.userTagsEndPoint = 'https://coin-service-users-server-zatxacztoa-uc.a.run.app';
CoinCloudApiWrapper.userDashboardEndPoint = 'https://coin-service-coin-user-dashboard-server-zatxacztoa-uc.a.run.app';
export default CoinCloudApiWrapper;
